import { gql } from "urql";
export const MoveLeadToPriorityEntryMutation = gql `
    mutation MoveLeadToPriorityEntry($websiteLeadId: String!) {
        websiteLeads {
            moveWebsiteLeadToPriorityEntry(websiteLeadId: $websiteLeadId) {
                websiteLeadId
                caregiverId
                patientId
                therapyCategoryId
                movedToPipeline
            }
        }
    }
`;
export const ArchiveWebsiteLeadMutation = gql `
    mutation ArchiveWebsiteLead($websiteLeadId: String!) {
        websiteLeads {
            archiveWebsiteLead(websiteLeadId: $websiteLeadId) {
                websiteLeadId
                archivedAt
            }
        }
    }
`;
export const RestoreWebsiteLeadMutation = gql `
    mutation RestoreWebsiteLead($websiteLeadId: String!) {
        websiteLeads {
            restoreWebsiteLead(websiteLeadId: $websiteLeadId) {
                websiteLeadId
                archivedAt
            }
        }
    }
`;
